export default __webpack_public_path__ + "static/exp1-84ba1638f0fa0cc0ba96c9f1c2f15216.webp";